import { Component, computed, input, output, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GeneralButtonComponent } from '../general-button/general-button.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-multi-select',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatListModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    TranslatePipe,
    GeneralButtonComponent,
  ],
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss',
})
export class MultiSelectComponent {
  readonly list = input<{ id: string | number; name: string }[]>([]);
  readonly selected = input.required<Set<string | number>>();
  readonly selectionChange = output<{ id: string | number; name: string }[]>();
  readonly resetFilter = output<void>();

  search = signal('');

  filteredList = computed(() => {
    const query = this.search().toLowerCase();
    return this.list().filter((u) => u.name?.toLowerCase().includes(query));
  });

  allSelected = computed(() => {
    const list = this.filteredList();
    return !!list.length && list.every((u) => this.selected().has(u.id));
  });

  someSelected = computed(() => {
    const list = this.filteredList();
    const selectedCount = list.filter((u) => this.selected().has(u.id)).length;
    return selectedCount > 0 && selectedCount < list.length;
  });

  toggleSelection(item: { id: string | number; name: string }): void {
    const updated = new Set(this.selected());
    if (updated.has(item.id)) {
      updated.delete(item.id);
    } else {
      updated.add(item.id);
    }

    this.emitSelection(updated);
  }

  toggleSelectAll(): void {
    const updated = new Set(this.selected());
    const list = this.filteredList();

    const allSelected = list.every((u) => updated.has(u.id));

    list.forEach((u) => (allSelected ? updated.delete(u.id) : updated.add(u.id)));

    this.emitSelection(updated);
  }

  setSearch(e: Event): void {
    this.search.set((e.target as HTMLInputElement).value);
  }

  private emitSelection(selectedIds: Set<string | number>): void {
    this.selectionChange.emit(this.list().filter((u) => selectedIds.has(u.id)));
  }
}
